<template>
  <Modal :open.sync="open" size="small">
    <div class="dwp-space-y-3">
      <div class="dwp-text-xl dwp-font-medium dwp-flex dwp-items-center dwp-space-x-2">Edit List</div>
      <TextInput
        data-cy="edit-list-title"
        @keydown.native.enter="submit"
        ref="listTitle"
        placeholder="Enter a list name"
        :value="form.title | decode"
        @input="value=>form.title=value"
      />
      <VButton @click.native="submit" data-cy="edit-list-save">Save</VButton>
      <VButton type="plain" @click.prevent.native="open = false">Cancel</VButton>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import TextInput from "@/components/ui/TextInput.vue";
import VButton from "@/components/ui/VButton.vue";
import { sync } from "vuex-pathify";

export default {
  components: {
    Modal,
    TextInput,
    VButton,
  },
  data() {
    return {
      form: {
        title: "",
      },
    };
  },
  computed: {
    open: sync("ui/modal@list.edit.open"),
    list: sync("ui/modal@list.edit.list"),
  },
  mounted() {
    this.form.title = this?.list?.title;
  },
  watch: {
    open(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.listTitle.focus();
        });
      }
    },
    "list.title"(val) {
      this.form.title = val;
    },
  },
  methods: {
    async submit() {
      this.open = false;
      let list = await this.$store.dispatch("lists/editList", {
        list: this.list,
        data: {
          title: this.form.title,
        },
      });
      this.form.title = "";
    },
  },
};
</script>